<template>
    <layout>
        <template v-slot:title>
            <img src="/logo.png" height="50" alt="" title="" style="vertical-align: middle;" class="mr-1" /><span>{{trans('layout.title')}}</span>
        </template>
        <template v-slot:header>
            <select-locale class="mx-2"></select-locale>
        </template>
        <slot></slot>
        <template v-slot:footer>
            <div class="text-center ma-2">{{trans('layout.footer')}}</div>
        </template>
    </layout>
</template>
<script>
import AppLayout from "./layout/AppLayout";
import SelectLocale from "./SelectLocale";

export default {
    props: {},
    data() {
        return {};
    },
    computed: {},
    methods: {},
    watch: {},
    filters: {},
    components:{
        SelectLocale,
        layout:AppLayout,
    }
}
</script>
